import { gql } from '@apollo/client'

export default gql(`
mutation updateMetaFieldConfig($id : ID!, $name: String!, $default: String,, $project: String!) {
    updateMetaFieldConfig(
        input: {
            id: $id
            name: $name
            default: $default
        }
        project : $project
    ) {
        id
        name
        type
        default
        section
    }
}`
)
